"use client";
import React from "react";
import { Root, Portal, Overlay, Content, Close, Title } from "@radix-ui/react-dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import styles from "./drawer.module.css";
import CloseIcon from "./closeIcon";
import classNames from "classnames";
function BottomDrawer({
  children,
  onClose,
  open,
  title = "Dialog",
}: React.PropsWithChildren<{
  open: boolean;
  onClose: (open: boolean) => void;
  title?: string;
}>) {
  return (
    <Root open={open} onOpenChange={onClose}>
      <Portal>
        <Overlay className={styles.overlay} />
        <Content className={styles.contentB}>
          <VisuallyHidden.Root>
            <Title>{title}</Title>
          </VisuallyHidden.Root>
          {children}
        </Content>
      </Portal>
    </Root>
  );
}

export default BottomDrawer;
